
import React, { useState } from 'react';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
import './Contact.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    // Basic validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      alert('Please fill in all required fields.');
      return;
    }
    
    // Handle form submission here
    alert('Thank you for your message! We will get back to you within 24 hours.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Get in Touch with Megapix Machinery
            </h1>
          </div>
        </div>
      </div>

      {/* Contact Information and Form */}
      <div className="contact-content">
        <div className="content-container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <h2 className="info-title">Contact Information</h2>
              
              <div className="info-items">
                <div className="info-item">
                  <MapPin className="info-icon" />
                  <div>
                    <h3 className="info-heading">📍 Office Address</h3>
                    <p className="info-text">
                      Jessore Road, Khudiram Colony,<br />
                      Kolkata, West Bengal, 700074<br />
                      India
                    </p>
                  </div>
                </div>
                
                <div className="info-item">
                  <Phone className="info-icon" />
                  <div>
                    <h3 className="info-heading">📞 Phone</h3>
                    <p className="info-text">
                      +91-9330566254<br />
                      <span className="info-hours">(Mon–Sat, 9:00 AM – 7:00 PM)</span>
                    </p>
                  </div>
                </div>
                
                <div className="info-item">
                  <Mail className="info-icon" />
                  <div>
                    <h3 className="info-heading">📧 Email</h3>
                    <p className="info-text">info@megapixmachinery.co.in</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form">
              <h2 className="form-title">📝 Contact Form</h2>
              <p className="form-description">Fill in your details and we'll get back to you within 24 hours.</p>
              
              <div className="form-fields">
                <div className="field">
                  <label className="field-label">
                    Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="field-input"
                  />
                </div>
                
                <div className="field">
                  <label className="field-label">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="field-input"
                  />
                </div>
                
                <div className="field">
                  <label className="field-label">
                    Phone *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="field-input"
                  />
                </div>
                
                <div className="field">
                  <label className="field-label">
                    Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows={5}
                    className="field-textarea"
                  ></textarea>
                </div>
                
                <button
                  onClick={handleSubmit}
                  className="submit-btn"
                >
                  <Send className="submit-icon" />
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;